export default {
  'options': {
    'units': {
      'kilometers': 'kilomètres',
      'meters': 'Mètres',
      'miles': 'Miles',
    },
    'areUnits': {
      'sqKms': 'Kms carrés',
      'hectare': 'Hectare',
      'sqMeters': 'Mètres carrés'
    }
  }
}
